import { render, staticRenderFns } from "./ClientPortfolioSubcompaniesModal.vue?vue&type=template&id=1c73ef5f&"
import script from "./ClientPortfolioSubcompaniesModal.vue?vue&type=script&lang=js&"
export * from "./ClientPortfolioSubcompaniesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports